import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GenericErrorHandlingDbErrorsService {

    public checkForDbErrors(logMessage: string) {
        let ediportalMessage = this.findEdiPortalMessage(logMessage);
        if (ediportalMessage) {
            let message = this.checkCode(ediportalMessage.errorCode);
            if (!message) {
                message = ediportalMessage.message;
            }

            if (ediportalMessage.extendedMessage) {
                message += '\r\n\r\n' + ediportalMessage.extendedMessage;
            }

            return message;
        }
        else { // Return the original error-message
            return logMessage;
        }
    }

    findEdiPortalMessage(text: string) {
        let ediportalMessageXml = this.findTagValue(text, '<EdiPortalMessage>', '</EdiPortalMessage>', true);
        if (ediportalMessageXml) {
            let ediPortalMessage = new EdiPortalMessage();
            ediPortalMessage.errorCode = +this.findTagValue(ediportalMessageXml, '<MessageCode>', '</MessageCode>');
            ediPortalMessage.message = this.findTagValue(ediportalMessageXml, '<Message>', '</Message>');
            ediPortalMessage.extendedMessage = this.findTagValue(ediportalMessageXml, '<ExtendedMessage>', '</ExtendedMessage>');
            return ediPortalMessage;
        }
        return null;
    }

    // Very simple way of 'parsing' XML. The benefits is the cross-browser support.
    findTagValue(text: string, startTag: string, endTag: string, includeTag: boolean = false) {
        let startIndex = text.indexOf(startTag);
        let endIndex = text.indexOf(endTag);

        if (startIndex >= 0 && endIndex > 0) {
            if (includeTag) {
                return text.substring(startIndex, endIndex + endTag.length);
            }
            else {
                return text.substring(startIndex + startTag.length, endIndex);
            }
        }
        return null;
    }

    checkCode(sqlErrorCode?: number) {
        // To be prepared for localization the error-messages are in this switch...
        switch (sqlErrorCode) {
            case 123456789: return 'This is a test-error-message! 123456789';
            case 4: return 'p_CheckForIssues_Configuration Failed test 1: Read committed snapshot is not enabled.';
            case 5: return 'p_CheckForIssues_TrackingCleanup Failed test 1: Documents exist that should have been deleted by maintenance jobs.';
            case 6: return 'p_CheckForIssues_TrackingCleanup Failed test 2: Ingoing interchanges exist that should have been deleted by maintenance jobs.';
            case 7: return 'p_CheckForIssues_TrackingCleanup Failed test 3: Outgoing interchanges exist that should have been deleted by maintenance jobs.';
            case 8: return 'p_CheckForIssues_TrackingCleanup Failed test 4: Interchanges exist that are not referenced from documents.';
            case 9: return 'Another Internal Partner uses the same Identification and IdentificationType.';
            case 10: return 'Another Partner uses the same Identification and IdentificationType.';
            case 13: return 'The DistributionDocument could not be found.';
            case 14: return 'No Itinerary could be found.';
            case 15: return 'Could not find ReceivePort in BizTalk management database.';
            case 16: return 'The ReceivePort did not have any Resubmit location';
            case 19: return 'The Distribution could not be found, Cannot update.';
            case 20: return 'The DocumentType could not be found.';
            case 21: return 'The DocumentConfig could not be found.';
            case 32: return 'The ApplicationServer could not be found.';
            case 34: return 'The ApplicationServer could not be found.';
            case 38: return 'The BatchingConfigLog could not be found.';
            case 40: return '@iBatchingConfigsId and @iDistributionsId cannot both be NULL.';
            case 44: return '@iFileLocation is null.';
            case 45: return '@iFormatFileLocation is null.';
            case 47: return '@iPartnerName is null.';
            case 52: return 'The FileTypeName could not be found.';
            case 78: return 'No DistributionConfigurations found.';
            case 83: return 'The DistributionLog could not be found';
            case 87: return 'The DistributionObject could not be found.';
            case 89: return 'Paramteters @iDistributionObjectFieldChoicesId and @iDistributionObjectFieldsId can\'t both be NULL';
            case 90: return 'All parameters can\'t be NULL!';
            case 91: return 'One of the following parameters must be provided: @iDistributionObjectFieldConditions_ValidationFieldRulesId, @iValidationFieldRulesId or @@iDistributionObjectFieldConditionsId';
            case 92: return 'Parameters @iDistributionObjectFieldConditions_ValidationFieldRulesId and @iValidationFieldRulesId';
            case 93: return 'At least one parameter must have a value';
            case 95: return 'The DistributionObject could not be found. Cannot update.';
            case 97: return 'The Distribution could not be found. Cannot delete.';
            case 99: return '@iCurrentUsersId cannot be NULL if @iUseDataAccessRestriction is not NULL or @iUseDataAccessRestrictionStrictMode is not NULL.';
            case 100: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestriction is 1.';
            case 101: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestrictionStrictMode is 1.';
            case 102: return '@iUseDataAccessRestrictionStrictMode cannot be 1 when @iUseDataAccessRestriction is 0.';
            case 104: return 'The Distribution could not be found. Cannot update.';
            case 105: return 'Cannot change transport configuration. Make sure that the outbox is empty first';
            case 108: return '@iDirection must be either \'\'In\'\' or \'\'Out\'\'.';
            case 498: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestriction is 1.';
            case 109: return 'No unique FullyQualifiedSchemaName was found';
            case 110: return 'The DistributionDocument could not be found.';
            case 111: return 'No Itinerary could be found.';
            case 112: return 'The Document could not be found. Cannot delete.';
            case 114: return 'At least one input parameter must be != NULL';
            case 115: return '@iDirection was not valid. Must be \'In\' or \'Out\'.';
            case 118: return '@iCurrentUsersId cannot be NULL if @iUseDataAccessRestriction is not NULL or @iUseDataAccessRestrictionStrictMode is not NULL.';
            case 119: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestriction is 1.';
            case 120: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestrictionStrictMode is 1.';
            case 121: return '@iUseDataAccessRestrictionStrictMode cannot be 1 when @iUseDataAccessRestriction is 0.';
            case 134: return 'The value of @iStatusTypeName is not a Document status.';
            case 135: return 'DistributionObject not found.';
            case 136: return '@iPartnersId or @iTransportTypeName must contain a value.';
            case 141: return '[Tracking].[pDocuments_Save] affected more than one row. That should not happen.';
            case 142: return '[Tracking].[pDocuments_Save] affected less than one row. That should not happen.';
            case 143: return '[Tracking].[pDocuments_Save] did not find the document specified by @iDocumentsId.';
            case 144: return 'Input list cannot be empty.';
            case 147: return 'Either @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList must be != NULL.';
            case 148: return 'Only one of @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList can be != NULL.';
            case 149: return 'Only one of @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList can be != NULL.';
            case 150: return 'Only one of @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList can be != NULL.';
            case 151: return 'Only one of @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList can be != NULL.';
            case 152: return 'Only one of @iDocumentsId, @iInterchangeGuid, @iInterchangeNumber, @iMessageGuid or @iDocumentsList can be != NULL.';
            case 153: return 'No documents found.';
            case 154: return 'Either @iStatusTypesId or @iStatusTypeName must be != NULL.';
            case 155: return 'Only one of @iStatusTypesId and @iStatusTypeName can be != NULL.';
            case 156: return 'Only one of @iStatusTypesId and @iStatusTypeName can be != NULL.';
            case 157: return 'No statusType found for that name.';
            // case 158: return  'No Application server found with the supplied name.'; -- Use the message from the DB as it includes application server name.
            case 159: return 'Either DocumentsId og DocumendtGuid must be filled out. Not both!';
            case 160: return '@iDirection must be either \'In\' or \'Out\'.';
            case 164: return 'The EdifactConfigLog could not be found.';
            case 167: return 'The EdifactConfigId could not be found. Cannot update EdifactConfig.';
            case 170: return 'The EdifactSuffix could not be found.';
            case 172: return 'The EdifactSuffix could not be found.';
            case 176: return 'The EdifactSyntax could not be found.';
            case 178: return 'The EdifactSyntax could not be found.';
            case 181: return 'The Environment could not be found.';
            case 183: return 'The local sql server is not classified as any environment.';
            case 185: return 'The local sql server is not classified as any environment.';
            case 190: return 'No ExceptionCategory found.';
            case 192: return 'No ExceptionInstance found.';
            case 194: return 'No ExceptionInstance found.';
            case 199: return 'No ExceptionType found.';
            case 201: return 'No ExceptionType found.';
            case 203: return 'No ExceptionType found.';
            case 206: return 'The FileAttachment could not be found. Cannot delete FileAttachment.';
            case 209: return 'The FileAttachment could not be found.';
            case 211: return 'The partner already has a partner agreement, a new one cannot be created.';
            case 216: return 'The PartnerAgreement could not be found. Cannot update FileAttachment.';
            case 218: return 'The FileAttachment could not be found. Cannot update FileAttachment.';
            case 220: return 'Both iFilenamingConfigsId and iDistributionsId are NULL. At least one of them must have a value. Cannot delete.';
            case 223: return 'The FlowConvoyPattern could not be found.';
            case 225: return 'The FlowConvoyPattern could not be found. Cannot update FlowConvoyPattern.';
            case 229: return 'The Format could not be found.';
            case 231: return 'The Format could not be found.';
            case 234: return 'The Format could not be found.';
            case 237: return 'The Gateway could not be found.';
            case 239: return '@iCurrentUsersId cannot be NULL when @iUseDataAccessRestriction is 1.';
            case 247: return 'The IdentificationType could not be found.';
            case 250: return 'The InConfiguration could not be found.';
            case 252: return 'The In Configuration could not be found. Cannot update Configuration.';
            case 254: return 'Invalid direction. Direction must be either \'In\' or \'Out\'.';
            case 258: return 'The Interchange could not be found.';
            case 260: return 'The Interchange could not be found.';
            case 262: return 'The Interchange could not be found.';
            case 264: return 'The Interchange could not be found.';
            case 266: return 'The Interchange could not be found.';
            case 269: return 'The Interchange could not be found.';
            case 271: return 'The Interchange could not be found.';
            case 273: return 'The Interchange could not be found.';
            case 275: return 'Interchange was not found in database.';
            case 277: return 'The interchange could not be found.';
            case 279: return 'The Interchange could not be found.';
            case 281: return 'The Interchange could not be found. Cannot update Interchange.';
            case 295: return 'The OutConfiguration could not be found.';
            case 297: return 'The Out Configuration could not be found. Cannot update Configuration.';
            case 301: return 'The Partner_IdentificationTypeLog could not be found.';
            case 304: return 'The Partner_IdentificationType could not be found, Cannot delete.';
            case 307: return 'The Partner_IdentificationType could not be found.';
            case 310: return 'The Partner_IdentificationType could not be found, Cannot update.';
            case 318: return 'The PartnerLog could not be found.';
            case 320: return 'The Partner is used on a distribution. Cannot delete.';
            case 321: return 'The Partner could not be found. Cannot delete.';
            case 322: return 'One of the following parameters must be provided: @iPartners_DistributionObjectFieldChoicesId, @iPartnersId or @iDistributionObjectFieldChoicesId';
            case 323: return '@iDoSearchByMainIdentification cannot be NULL when @iIdentificationValue is not NULL.';
            case 324: return 'iDoSearchByMainIdentification cannot be NULL when @iIdentificationTypeName is not NULL';
            case 327: return 'The save procedure affected more than one row.';
            case 330: return 'The PartnerType could not be found.';
            case 334: return 'No Permission found.';
            case 336: return 'The supplied proxy partner is not configured as one.';
            case 337: return 'Not all supplied non-proxy partners are configured as non-proxy partners.';
            case 345: return 'No RolePermission found.';
            case 347: return 'No Role Found, cannot delete.';
            case 351: return 'No Role found.';
            case 352: return 'No Role Found, cannot update.';
            case 358: return 'The Sequence could not be found.';
            case 365: return 'The SqlServer could not be found.';
            case 370: return 'No Stakeholder found.';
            case 384: return 'No StatusTypeGroup found.';
            case 386: return 'No StatusTypeGroup found.';
            case 388: return 'The StatusTypeGroup could not be found. Cannot update group.';
            case 394: return 'No StatusType found.';
            case 396: return 'No StatusType found.';
            case 398: return 'The StatusType could not be found. Cannot update type.';
            case 400: return 'At least one parameter must be != NULL.';
            case 401: return 'At least one parameter must be != NULL.';
            case 409: return 'At least one parameter must be != NULL.';
            case 412: return 'The TrackingFieldType could not be found. Cannot update type.';
            case 416: return 'The TransportConfigurationLog could not be found.';
            case 419: return 'The TransportConfiguration is used on a distribution. Cannot delete.';
            case 420: return 'The TransportConfiguration could not be found. Cannot delete.';
            case 424: return 'The TransportConfiguration could not be found.';
            case 427: return '5ssThe TransportConfiguration could not be found. Cannot update TransportConfiguration.427';
            case 428: return 'Cannot change transport type. Make sure that the outbox is empty first.';
            case 432: return 'The TransportConvoyPattern could not be found.';
            case 434: return 'The TransportConvoyPattern could not be found. Cannot update TransportConvoyPattern.';
            case 437: return 'The TransportResponseType could not be found.';
            case 442: return 'The TransportTypeFieldInstance could not be found.';
            case 446: return 'The TransportTypeField could not be found.';
            case 450: return 'User group cannot be found.';
            case 451: return 'The user group has failed documents assigned to it and cannot be deleted. Please handle the failed documents or assign them to another user group.';
            case 452: return 'The user group is used for assigning errors and cannot be deleted. Please use another usergroup for error assignments.';
            case 457: return 'No UserGroup Found.';
            case 458: return 'No UserGroup Found, cannot update.';
            case 461: return 'No UserGroupUser Found, cannot delete.';
            case 463: return 'Parameters @iValidationFieldRulesId, @iDistributionObjectsId and @iDocumentConfigsId can\'\'t all be NULL';
            case 464: return 'Could not insert DocumentConfigsId. The DistributionObjectField and DocumentConfig are not related.';
            case 465: return 'Parameter @iValidationRequirementTypesId can\'\'t be NULL';
            case 466: return 'Parameters @iDistributionObjectsId and @iDocumentConfigsId can\'t both be NULL';
            case 467: return 'Parameters @iDistributionObjectsId and @iDocumentConfigsId can\'\'t both be NULL';
            case 468: return 'Parameter @iValidationFileGuid can\'\'t be NULL';
            case 471: return 'The Variant could not be found.';
            case 473: return 'The Variant could not be found.';
            case 477: return 'The VariantVersion could not be found.';
            case 479: return 'The VariantVersion could not be found.';
            default: return undefined;
        }
    }
}

export class EdiPortalMessage {
    constructor(public errorCode?: number, public message?: string, public extendedMessage?: string) { }
}
